module.exports = require("@platform/front-ui");